import React, { useMemo } from 'react';
import clsx from 'clsx';
import useCheckoutState from '../../../hooks/useCheckoutState';
import useAiTarget from '../../../hooks/useAiTarget';
import getThemeLabels from '../../../lib/getThemeLabels';
import CouponField from './CouponField';

export default function DiscountCodeBox({ className }) {
  const { checkout, theme, showCouponCodeField, setShowCouponCodeField } = useCheckoutState();
  const aiTarget = useAiTarget();
  const labels = useMemo(() => getThemeLabels(theme), [theme]);

  if (!checkout.showCouponCodeField) return null;

  return (
    <div className={clsx('cp_coupon-wrapper', className)} {...aiTarget('discountCode')}>
      {!showCouponCodeField && (
        <div className="cp_coupon-add-wrapper">
          <button
            type="button"
            onClick={() => setShowCouponCodeField(true)}
            className={clsx(
              'cp_coupon-add-button underline',
              'hover:text-[var(--cp_checkout-form-fields-discountCode-link-color-hover)]',
              'text-[var(--cp_checkout-form-fields-discountCode-link-color)]',
              '[font-weight:var(--cp_checkout-form-fields-discountCode-link-font-weight)]',
            )}
          >
            {labels.addDiscountCodeText}
          </button>
        </div>
      )}

      {showCouponCodeField && (
        <div className="cp_coupon-field-wrapper">
          <CouponField />
        </div>
      )}
    </div>
  );
}
